export const roundTo2Decimals = (value: number): number => {
  return Math.round((value + Number.EPSILON) * 100) / 100;
};
